// extracted by mini-css-extract-plugin
export default {"container":"AssocListPopup__container___WKL3v","actions":"AssocListPopup__actions___bUlyQ"};